"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sizes = exports.default = exports.StyledType = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _breakpoints = _interopRequireDefault(require("../breakpoints"));
require("./fonts.css");
var _jsxRuntime = require("react/jsx-runtime");
const trackingToLetterSpacing = function (spacing) {
  return `${spacing / 1000}em`;
};
const originalSizes = {
  display1: `
    font-size: 30px;
    line-height: 32px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 60px;
      line-height: 62px;
    }
  `,
  display2: `
    font-size: 45px;
    line-height: 48px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 55px;
      line-height: 58px;
    }
  `,
  display3: `
    font-size: 36px;
    line-height: 42px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 50px;
      line-height: 58px;
    }
  `,
  heading1: `
    font-size: 30px;
    line-height: 40px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 50px;
      line-height: 60px;
    }
  `,
  heading2: `
    font-size: 32px;
    line-height: 38px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 36px;
      line-height: 42px;
    }
  `,
  heading3: `
    font-size: 36px;
    line-height: 42px;
  `,
  heading4: `
    font-size: 30px;
    line-height: 32px;
  `,
  heading5: `
    font-size: 24px;
    line-height: 30px;
  `,
  heading6: `
    font-size: 18px;
    line-height: 22px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 24px;
      line-height: 28px;
    }
  `,
  heading7: `
    font-size: 28px;
    line-height: 21px;

    ${(0, _breakpoints.default)("tablet", "up")}{
      font-size: 40px;
      line-height: 32px;
    }
  `,
  heading8: `
    font-size: 30px;
    line-height: 24px;

    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 36px;
      line-height: 31px;
    }}
  `,
  subHeading1: `
    font-size: 18px;
    line-height: 22px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 20px;
      line-height: 24px;
    }
  `,
  subHeading2: `
    font-size: 18px;
    line-height: 26px;
  `,
  subHeading3: `
    font-size: 16px;
    line-height: 24px;
  `,
  subHeading4: `
    font-size: 12px;
    line-height: 26px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 14px;
      line-height: 18px;
    }
  `,
  subHeading5: `
    font-size: 20px;
    line-height: 24px;
  `,
  bodyCopy1: `
    font-size: 14px;
    line-height: 20px;
  `,
  bodyCopy2: `
    font-size: 12px;
    line-height: 18px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 14px;
      line-height: 20px;
    }
  `,
  bodyCopy3: `
    font-size: 12px;
    line-height: 18px;
  `,
  linkCopy1: `
    font-size: 13px;
    line-height: 18px;
  `,
  linkCopy2: `
    font-size: 11px;
    line-height: 16px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 13px;
      line-height: 18px;
    }
  `,
  linkCopy3: `
    font-size: 11px;
    line-height: 14px;
  `,
  linkCopy4: `
    font-size: 10px;
    line-height: 12px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 11px;
      line-height: 14px;
    }
  `,
  legalCopy1: `
    font-size: 10px;
    line-height: 12px;
  `,
  legalCopy2: `
    font-size: 8px;
    line-height: 10px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 10px;
      line-height: 12px;
    }
  `,
  legalCopy3: `
    font-size: 8px;
    line-height: 10px;
  `,
  /* The following are deprecated */
  body: `
    font-size: 14px;
    line-height: 20px;
  `,
  button: `
    font-size: 13px;
    line-height: 18px;
  `,
  linkCopy: `
    font-size: 11px;
    line-height: 14px;
  `,
  disclaimerBody: `
    font-size: 10px;
    line-height: 14px;
  `,
  disclaimer: `
    font-size: 10px;
    line-height: 12px;
  `,
  pricing: `
      font-size: 45px;
      line-height: 48px;
    ${(0, _breakpoints.default)("tablet", "up")} {
      font-size: 55px;
      line-height: 58px;
    }
  `,
  iconLabel: `
    font-size: 8px;
    line-height: 10px;
  `
};
const sizes = exports.sizes = {
  ...originalSizes,
  header1: originalSizes.heading1,
  header2: originalSizes.heading2,
  header3: originalSizes.heading3,
  header4: originalSizes.heading4,
  header5: originalSizes.heading5,
  header6: originalSizes.heading6,
  header7: originalSizes.heading7,
  header8: originalSizes.heading8,
  subHeader1: originalSizes.subHeading1,
  subHeader2: originalSizes.subHeading2,
  subHeader3: originalSizes.subHeading3,
  subHeader4: originalSizes.subHeading4,
  subHeader5: originalSizes.subHeading5
};
sizes.default = sizes.body;
const StyledTypography = _styledComponents.default.span`
  font-weight: normal;
  font-family: ${function (_ref) {
  let {
    $family
  } = _ref;
  return $family;
}};
  margin: 0;
  letter-spacing: ${function (_ref2) {
  let {
    $letterSpacing
  } = _ref2;
  return trackingToLetterSpacing($letterSpacing === "wide" ? 100 : 40);
}};
  ${function (_ref3) {
  let {
    $size
  } = _ref3;
  return sizes[$size] ? sizes[$size] : sizes.default;
}}
`;
const Typography = /*#__PURE__*/_react.default.forwardRef(function (props, ref) {
  let {
    family,
    weight,
    size,
    letterSpacing,
    ...rest
  } = props;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledTypography, {
    ref: ref,
    ...rest,
    $weight: weight,
    $family: family,
    $size: size,
    $letterSpacing: letterSpacing,
    "data-testid": "Typography"
  });
});
Typography.defaultProps = {
  family: "nobel-regular",
  size: "body",
  letterSpacing: "narrow"
};
/* Deprecated - For backwards compatibility */
Typography.heading1 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading1",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.heading2 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading2",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.heading3 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading3",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.heading4 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading4",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.heading5 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading5",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.heading6 = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "heading6",
    family: props.family || "nobel-regular",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.body = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "body",
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.bodyBold = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "body",
    family: props.family || "nobel-bold",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.bodyAlternate = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "body",
    family: props.family || "Palatino",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.button = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "button",
    family: props.family || "nobel-bold",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.disclaimer = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "disclaimer",
    family: props.family || " Palatino",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.pricing = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "pricing",
    family: props.family || "pakt",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.regular = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    family: props.family || "nobel-regular",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.book = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    family: props.family || "nobel-book",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.iconLabel = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "iconLabel",
    family: props.family || "nobel-regular",
    letterSpacing: props.letterSpacing || "narrow"
  };
})``;
Typography.disclaimerBody = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "disclaimerBody",
    family: props.family || "nobel-regular",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
Typography.linkCopy = (0, _styledComponents.default)(Typography).attrs(function (props) {
  return {
    size: "linkCopy",
    family: props.family || "nobel-bold",
    letterSpacing: props.letterSpacing || "wide"
  };
})``;
const StyledType = function (element) {
  let attrs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return (0, _styledComponents.default)(Typography).attrs(function (props) {
    return {
      forwardedAs: element,
      ...(typeof attrs === "function" ? attrs(props) : attrs),
      // prevent id attribute from being spread (results in duplicate id on page)
      id: undefined
    };
  });
};

/* Deprecated - For backwards compatibility */
exports.StyledType = StyledType;
for (let key in Typography) {
  if (Typography.hasOwnProperty(key)) {
    StyledType[key] = function (component) {
      return (0, _styledComponents.default)(Typography[key]).attrs({
        forwardedAs: component
      });
    };
  }
}
var _default = exports.default = Typography;